import CloseIcon from '@/shared/assets/icons/profile/close.svg?react'
import { BaseButton } from '@/shared/components'
import { ColumnDef } from '@tanstack/react-table'
import { SessionModel } from '../types/session'

export const getColumns = (onCloseHandler: () => void): ColumnDef<SessionModel>[] => [
  {
    accessorKey: 'session',
    header: 'Сессия',
    cell: ({ row }) => {
      const info = row.original.info
      const id = row.original.id
      const status = row.original.status

      return (
        <div className="flex items-center gap-[10px]">
          <div
            className={`shrink-0 w-2 h-2 rounded-full ${status === 'current' ? 'bg-text-completed' : 'bg-text-main'}`}
          ></div>
          <div className="flex flex-col">
            <span className="font-klein font-medium text-text-main dark:text-white truncate w-[300px] overflow-hidden text-ellipsis whitespace-nowrap">
              {info}
            </span>
            <span className="text-xs text-text-secondary">{id}</span>
          </div>
        </div>
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: ({ row }) => {
      const status = row.original.status

      return (
        <>
          {status === 'current' ? (
            <span className="text-text-main dark:text-white">Текущая сессия</span>
          ) : (
            <div className="flex items-center gap-[3px]">
              <span>{status}</span>
              <BaseButton variant="ghost" padding="none" onClick={onCloseHandler}>
                <CloseIcon className="text-text-secondary w-4 h-4" />
              </BaseButton>
            </div>
          )}
        </>
      )
    },
  },
]
